/*
    This code was automatically generated.
    Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
*/

import { DataField } from '../DataField';
import * as DataFieldHelper from '../DataFieldHelper';
import { addContractField } from '../Contract';

export namespace Result {
  const contractName = 'Office.System.Result';

  export interface Contract {
    code: number;
    type?: string;
    tag?: number;
  }

  /* Gets data fields for the Office.System.Result contract */
  export function getFields(instanceName: string, contract: Contract): DataField[] {
    let dataFields: DataField[] = [];
    dataFields.push(DataFieldHelper.makeInt64DataField(`${instanceName}.Code`, contract.code));
    if (contract.type !== undefined) {
      dataFields.push(DataFieldHelper.makeStringDataField(`${instanceName}.Type`, contract.type));
    }
    if (contract.tag !== undefined) {
      dataFields.push(DataFieldHelper.makeInt64DataField(`${instanceName}.Tag`, contract.tag));
    }
    addContractField(dataFields, instanceName, contractName);
    return dataFields;
  }
} // Result
export namespace Activity {
  export const contractName = 'Office.System.Activity';

  export interface Contract {
    cV?: string;
    duration: number;
    count: number;
    aggMode: number;
    success?: boolean;
    result?: Result.Contract;
  }

  /* Gets data fields for the Office.System.Activity contract */
  export function getFields(contract: Contract): DataField[] {
    const instanceName = 'Activity';
    let dataFields: DataField[] = [];
    if (contract.cV !== undefined) {
      dataFields.push(DataFieldHelper.makeStringDataField(`${instanceName}.CV`, contract.cV));
    }
    dataFields.push(DataFieldHelper.makeInt64DataField(`${instanceName}.Duration`, contract.duration));
    dataFields.push(DataFieldHelper.makeInt64DataField(`${instanceName}.Count`, contract.count));
    dataFields.push(DataFieldHelper.makeInt64DataField(`${instanceName}.AggMode`, contract.aggMode));
    if (contract.success !== undefined) {
      dataFields.push(DataFieldHelper.makeBooleanDataField(`${instanceName}.Success`, contract.success));
    }
    if (contract.result !== undefined) {
      dataFields.push(...Result.getFields(`${instanceName}.Result`, contract.result));
    }
    addContractField(dataFields, instanceName, contractName);
    return dataFields;
  }
} // Activity
export namespace Host {
  const contractName = 'Office.System.Host';

  export interface Contract {
    id?: string;
    version?: string;
    sessionId?: string;
  }

  /* Gets data fields for the Office.System.Host contract */
  export function getFields(instanceName: string, contract: Contract): DataField[] {
    let dataFields: DataField[] = [];
    if (contract.id !== undefined) {
      dataFields.push(DataFieldHelper.makeStringDataField(`${instanceName}.Id`, contract.id));
    }
    if (contract.version !== undefined) {
      dataFields.push(DataFieldHelper.makeStringDataField(`${instanceName}.Version`, contract.version));
    }
    if (contract.sessionId !== undefined) {
      dataFields.push(DataFieldHelper.makeStringDataField(`${instanceName}.SessionId`, contract.sessionId));
    }
    addContractField(dataFields, instanceName, contractName);
    return dataFields;
  }
} // Host
export namespace SDX {
  const contractName = 'Office.System.SDX';

  export interface Contract {
    id?: string;
    version?: string;
    instanceId?: string;
    name?: string;
    marketplaceType?: string;
    sessionId?: string;
    browserToken?: string;
    osfRuntimeVersion?: string;
    officeJsVersion?: string;
    hostJsVersion?: string;
    assetId?: string;
    providerName?: string;
    type?: string;
    url?: string;
  }

  /* Gets data fields for the Office.System.SDX contract */
  export function getFields(instanceName: string, contract: Contract): DataField[] {
    let dataFields: DataField[] = [];
    if (contract.id !== undefined) {
      dataFields.push(DataFieldHelper.makeStringDataField(`${instanceName}.Id`, contract.id));
    }
    if (contract.version !== undefined) {
      dataFields.push(DataFieldHelper.makeStringDataField(`${instanceName}.Version`, contract.version));
    }
    if (contract.instanceId !== undefined) {
      dataFields.push(DataFieldHelper.makeStringDataField(`${instanceName}.InstanceId`, contract.instanceId));
    }
    if (contract.name !== undefined) {
      dataFields.push(DataFieldHelper.makeStringDataField(`${instanceName}.Name`, contract.name));
    }
    if (contract.marketplaceType !== undefined) {
      dataFields.push(DataFieldHelper.makeStringDataField(`${instanceName}.MarketplaceType`, contract.marketplaceType));
    }
    if (contract.sessionId !== undefined) {
      dataFields.push(DataFieldHelper.makeStringDataField(`${instanceName}.SessionId`, contract.sessionId));
    }
    if (contract.browserToken !== undefined) {
      dataFields.push(DataFieldHelper.makeStringDataField(`${instanceName}.BrowserToken`, contract.browserToken));
    }
    if (contract.osfRuntimeVersion !== undefined) {
      dataFields.push(DataFieldHelper.makeStringDataField(`${instanceName}.OsfRuntimeVersion`, contract.osfRuntimeVersion));
    }
    if (contract.officeJsVersion !== undefined) {
      dataFields.push(DataFieldHelper.makeStringDataField(`${instanceName}.OfficeJsVersion`, contract.officeJsVersion));
    }
    if (contract.hostJsVersion !== undefined) {
      dataFields.push(DataFieldHelper.makeStringDataField(`${instanceName}.HostJsVersion`, contract.hostJsVersion));
    }
    if (contract.assetId !== undefined) {
      dataFields.push(DataFieldHelper.makeStringDataField(`${instanceName}.AssetId`, contract.assetId));
    }
    if (contract.providerName !== undefined) {
      dataFields.push(DataFieldHelper.makeStringDataField(`${instanceName}.ProviderName`, contract.providerName));
    }
    if (contract.type !== undefined) {
      dataFields.push(DataFieldHelper.makeStringDataField(`${instanceName}.Type`, contract.type));
    }
    if (contract.url !== undefined) {
      dataFields.push(DataFieldHelper.makeStringDataField(`${instanceName}.Url`, contract.url));
    }
    addContractField(dataFields, instanceName, contractName);
    return dataFields;
  }
} // SDX
export namespace Funnel {
  const contractName = 'Office.System.Funnel';

  export interface Contract {
    name?: string;
    state?: string;
  }

  /* Gets data fields for the Office.System.Funnel contract */
  export function getFields(instanceName: string, contract: Contract): DataField[] {
    let dataFields: DataField[] = [];
    if (contract.name !== undefined) {
      dataFields.push(DataFieldHelper.makeStringDataField(`${instanceName}.Name`, contract.name));
    }
    if (contract.state !== undefined) {
      dataFields.push(DataFieldHelper.makeStringDataField(`${instanceName}.State`, contract.state));
    }
    addContractField(dataFields, instanceName, contractName);
    return dataFields;
  }
} // Funnel
export namespace UserAction {
  const contractName = 'Office.System.UserAction';

  export interface Contract {
    id?: number;
    name?: string;
    commandSurface?: string;
    parentName?: string;
    triggerMethod?: string;
    timeOffsetMs?: number;
  }

  /* Gets data fields for the Office.System.UserAction contract */
  export function getFields(instanceName: string, contract: Contract): DataField[] {
    let dataFields: DataField[] = [];
    if (contract.id !== undefined) {
      dataFields.push(DataFieldHelper.makeInt64DataField(`${instanceName}.Id`, contract.id));
    }
    if (contract.name !== undefined) {
      dataFields.push(DataFieldHelper.makeStringDataField(`${instanceName}.Name`, contract.name));
    }
    if (contract.commandSurface !== undefined) {
      dataFields.push(DataFieldHelper.makeStringDataField(`${instanceName}.CommandSurface`, contract.commandSurface));
    }
    if (contract.parentName !== undefined) {
      dataFields.push(DataFieldHelper.makeStringDataField(`${instanceName}.ParentName`, contract.parentName));
    }
    if (contract.triggerMethod !== undefined) {
      dataFields.push(DataFieldHelper.makeStringDataField(`${instanceName}.TriggerMethod`, contract.triggerMethod));
    }
    if (contract.timeOffsetMs !== undefined) {
      dataFields.push(DataFieldHelper.makeInt64DataField(`${instanceName}.TimeOffsetMs`, contract.timeOffsetMs));
    }
    addContractField(dataFields, instanceName, contractName);
    return dataFields;
  }
} // UserAction
